import React, { useEffect, useState } from 'react';
import { getMyBrandBusinessDetailForAgency } from '../../../store/agencyStore/actions/getMyBrandBusinessDetailForAgencyActions';
import { useDispatch } from 'react-redux';

const BrandFilterBar = ({
  dataList = [],
  optionLabel = 'All Brand Name',
  onFilter = () => {},
  onReset = () => {}
}) => {

  const dispatch = useDispatch();
  const [selectedBrand, setSelectedBrand] = useState('');
  const [brands, setBrands] = useState([]);

  const handleFilter = () => {
    onFilter(selectedBrand);
  };

  const handleReset = () => {
    setSelectedBrand('');
    onReset();
  };

  useEffect(() => {
    if (!dataList.length) {
      console.log("dataList", dataList);
      dispatch(getMyBrandBusinessDetailForAgency({}, (status, response, message) => {
        if (status === 200) {
          console.log("response", response);
          setBrands(response);
        }
      }))
      return;
    }
    if (dataList.length) {
      console.log("dataList", dataList);
      setBrands(dataList);
    }
  }, []);

  return (
    <div className="bg-white rounded-md shadow p-4 flex items-center justify-between w-full">
      <div className="flex items-center gap-4">
        <label htmlFor="brandSelect" className="font-medium poppins-medium text-[#534D4D] text-[1.6rem]">
          Filter
        </label>
        <select
          id="brandSelect"
          className="border border-gray-300 rounded px-3 py-2 w-[20rem] poppins-regular text-[1.4rem]"
          value={selectedBrand}
          onChange={(e) => {console.log("e", e.target.value); setSelectedBrand(e.target.value)}}
        >
          <option value="">{optionLabel}</option>
          {brands?.map((brand, idx) => (
            <option key={idx} value={brand.brandId}>
              {brand.name}
            </option>
          ))}
        </select>
      </div>

      <div className="flex gap-2">
        <button
          onClick={handleFilter}
          className="bg-green-600 text-white px-5 py-2 rounded hover:bg-green-700 poppins-medium text-[1.4rem]"
        >
          Filter
        </button>
        <button
          onClick={handleReset}
          className="border border-green-600 text-green-600 px-5 py-2 rounded hover:bg-green-50 poppins-medium text-[1.4rem]"
        >
          Reset
        </button>
      </div>
    </div>
  );
};

export default BrandFilterBar;
